module.exports = __webpack_public_path__ + "static/media/press12.fa5750bb.png";